import { BaseModel, fillOwnProperties } from '~/shared/model'
import { isUnknownObject } from '~/shared/utils/guards'

export default class TextNumber extends BaseModel {
  static override constructorName = 'TextNumber'

  public number: string = ''
  public text: string = ''

  constructor(data?: unknown) {
    super(data)
    if (isUnknownObject(data)) {
      fillOwnProperties(this, data)
    }
  }
}
